import { PaginatedLog } from '../types';

export const calculateTotalLogsCount = (
  logs: Record<string, PaginatedLog[]> | null | undefined,
): number => {
  if (!logs) return 0;

  return Object.keys(logs).reduce((count, runIdKey) => {
    const runLogs = logs[runIdKey];
    return count + (Array.isArray(runLogs) ? runLogs.length : 0);
  }, 0);
};
